import React, { useEffect } from 'react';

function PrivacyTeam() {
  useEffect(()=>{
    window.scrollTo({
        top:0,
        behavior:"smooth"
    })
},[])
  return (
    <div>
      <h2>Our Privacy Team</h2>
      <p>At Stickers-Design, we take privacy seriously. Our dedicated team works tirelessly to ensure that your data is safe and secure. Meet the members of our privacy team:</p>
      <ul className='w-50 mx-auto'>
        <li><strong>Griach Tahar</strong> - Privacy Officer</li>
        <li><strong>Aliqui Zaid </strong> - Data Protection Specialist</li>
        <li><strong>Griach Tahar</strong> - Compliance Manager</li>
      </ul>
      <p>Have any privacy concerns or questions? Feel free to reach out to our team contact </p>
    </div>
  );
}

export default PrivacyTeam;
